import { render, staticRenderFns } from "./MarketingHeader.vue?vue&type=template&id=eaff53f4&scoped=true&"
import script from "./MarketingHeader.vue?vue&type=script&lang=ts&"
export * from "./MarketingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingHeader.vue?vue&type=style&index=0&id=eaff53f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaff53f4",
  null
  
)

export default component.exports